import { Form, Segment } from "semantic-ui-react";

const CDVForm = (props) => {
  let { docId, setDocId, handleSubmit } = props;
  return (
    <Segment compact id="cdv-form-seg" textAlign="center">
      <Form id="cdv-form" onSubmit={handleSubmit} size="small">
        <Form.Group>
          <Form.Input
            inline
            id="document-id-input"
            label={{ children: 'Enter Document ID:', htmlFor: 'document-id-input' }}
            value={docId}
            onChange={(e) => {
              setDocId(e.target.value);
            }}
          />
          <Form.Button size="small" color="blue" type="submit">
            Submit
          </Form.Button>
        </Form.Group>
      </Form>
    </Segment>
  );
};

export default CDVForm;
